/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { MetaData } from "../Courses/GetAllRequests";
export type NewsLetterDTO = {
  id: string;
  email: string;
  createdAt: string;
}


interface NewsLetterData {
  newsLetters: NewsLetterDTO[];
  metaData: MetaData;
}

interface NewsLetterResponse {
  data?: NewsLetterData;
  error?: ApiError;
}

interface GetNewsLetterParams {
  page: number;
  limit: number;
}

export const getAllNewsLetter = async ({ page, limit }: GetNewsLetterParams): Promise<NewsLetterResponse> => {
  try {
    const response = await axios.get(`/news-letter/all`, {
      params: { page, limit },
    });
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
